import i18next from 'i18next'
import 'reflect-metadata'
import {injectable} from 'inversify'
import {action, makeObservable, observable} from 'mobx'
import {Tab} from '@/components/dumb/Tabs/props'
import {TRangePickerContainerStore, TTabsContainerStore} from '@/components'
import {hasPermissions} from '@/stores/auth/services'
import {PermissionsMap} from '@/stores/auth/constants/permissions-map'

@injectable()
export class OverviewBetaTabsContainerStore implements TTabsContainerStore {
    tabs: Tab[]
    value: 'payments' | 'settlements'
    _rangePickerStore: TRangePickerContainerStore

    constructor() {
        this.tabs = [
            hasPermissions([PermissionsMap.pos_payments.read, PermissionsMap.online_payments.read, PermissionsMap.pos_payments.full, PermissionsMap.online_payments.full]) && {
                title: i18next.t('Overview.payments'),
                disabled: false,
                key: 'payments'
            },
            hasPermissions([PermissionsMap.settlements.read, PermissionsMap.settlements.full]) && {
                title: i18next.t('Overview.settlements'),
                disabled: false,
                key: 'settlements'
            }
        ].filter((tab) => !!tab)

        this.value = hasPermissions([PermissionsMap.pos_payments.read, PermissionsMap.online_payments.read, PermissionsMap.pos_payments.full, PermissionsMap.online_payments.full]) 
            ? 'payments'
            : 'settlements'

        makeObservable(this, {
            value: observable,
            tabs: observable,
            setValue: action.bound
        })
    }

    public clear() {
        this.value = null
    }

    setValue(value) {
        this.value = value
    }

    public setTabs(tabs: Tab[]): void {
        this.tabs = tabs
    }
}
